import playStore from "../../../img/icons/apps/GooglePlay-store-ES.png"
import appStore from "../../../img/icons/apps/app-store-ES.svg"
import ImgMobileApp from '../../../img/06.png'
import mobileImg from "../../../img/icons/apps/mobile-icon-white.svg"
const MobileApp = () => {
  return (
    <div className="remarkable_section bg-gray container-apps-mobile">
      <div className="container ">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col">
                <div className="app-section">
                     {/* <img src={mobileImg} alt="mobile" className="img-mobile"/> */}
                  <div className="container-img-mobileapp col-md-6 col-sm-12">
                    <img src={ImgMobileApp} alt="Imagen movil" />
                  </div>
                  <div className="container-text-mobileapp col-md-6 col-sm-12">
                    <h2 className="section-title_big">
                      Descarga Solimat App
                    </h2>
                   
                    <p className="descriptive-text">
                     <span style={{color:"#40A6D7",fontWeight:'bold'}}> SOLIMAT</span> ha puesto a disposición de los usuarios del Portal de Paciente las aplicaciones para móviles <span style={{color:"#40A6D7",fontWeight:'bold'}}> IOS</span> y <span style={{color:"#40A6D7",fontWeight:'bold'}}> Android</span>. De esta forma los usuarios del Portal de Paciente podrán gestionar sus prestaciones desde sus dispositivos móviles.
                    </p>
                    
                    {/* Botones de las tiendas de aplicaciones */}
                    <div className="app-store-buttons">
                      {/* Botón de Google Play Store */}
                      <a 
                        href="https://play.google.com/store/apps/details?id=com.solimat.paciente" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="store-button"
                      >
                        <img 
                          src={playStore} 
                          alt="Descargar en Google Play" 
                          className="store-button-img"
                        />
                      </a>
                      
                      {/* Botón de Apple App Store */}
                      <a 
                        href="https://apps.apple.com/es/app/portal-paciente-solimat/id6745520018" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="store-button"
                      >
                        <img 
                          src={appStore}
                          alt="Descargar en App Store" 
                          className="store-button-img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MobileApp;